import styled from 'styled-components';
import { Text } from '@cko/primitives';

export const IABreadCrumbButton = styled.button`
  padding: var(--layout-soybean) var(--layout-stamp);
  justify-content: space-between;
  display: flex;
  align-items: center;
  gap: var(--layout-seed);
  border: none;
  background-color: var(--base-bg-primary);
  cursor: pointer;
  font: var(--body-sm);
  color: var(--base-text-primary);
  padding-left: 0;
`;

export const ExpandIconContainer = styled.div`
  height: 16px,
  width: 16px,
  display: inline,
  alignItems: center,
`;

export const SubEntityBreadcrumbFont = styled(Text)`
  color: var(--control-text-secondary);
  font: var(--helper-sm);
  max-width: 300px;
`;
